<template>
  <div class="lesson-wrapper">

    <div v-if="!isWxMini" class="lesson-header">超级简历教育</div>
    <div class="lesson-banner-box">
      <!-- <div ref="scrollDom" class="lesson-banner-box-scroll" v-if="bannerData && bannerData.length" @touchstart="mouseDownFun" @touchmove="mouseMoveFun">

        <div class="lesson-banner-item" v-for="(itemBanner, indexBanner) in bannerData" :key="'indexBanner&' + indexBanner">
          <img :src="itemBanner.image" alt="">
          <a :href="itemBanner.link"></a>
        </div>

      </div> -->
      <Banner v-if="bannerData && bannerData.length" :bannerData="bannerData"></Banner>
    </div>
    <goodLocation></goodLocation>

    <template v-if="recommendData && recommendData.length">
      <div class="lesson-title">限时推荐</div>
      <div class="lesson-recommend-box">
        <img :src="recommendData[0].image" alt="">
        <a :href="recommendData[0].link"></a>
      </div>
    </template>

    <template v-if="hotData && hotData.length">
      <div class="lesson-title">热门课程</div>
      <div class="lesson-hot-box">
        <div class="lesson-hot-item" v-for="(itemHot, indexHot) in hotData" :key="'indexHot&' + indexHot">
          <img :src="itemHot.image" alt="">
          <a :href="itemHot.link"></a>
        </div>
      </div>
    </template>


    <!-- 底部 tab -->
    <!-- <w-tabbar v-show="iosOrAndroidShow" :page="'lesson'"/> -->

  </div>
</template>

<script>
import api from "@/api/api-list"
import WTabbar from '@/components/global/w-tabbar'
import Banner  from "./components/banner/index"
import goodLocation from '@/views/lesson/components/goodLocation'
import { envMixin } from '../../assets/js/mixin/global'
export default {
  mixins: [ envMixin ],
  data () {
    return {
      bannerData: [],
      recommendData: [],
      hotData: [],
      prevX: 0,
      nextX: 0,
      scrollLock: true,
      clientWidth: document.body.clientWidth
    }
  },
  components: {
    WTabbar,
    Banner,
    goodLocation
  },
  created () {
    try {

      let banner = api.jobs.getBannerImg({position: 65})
      let recommend = api.jobs.getBannerImg({position: 66})
      let hot = api.jobs.getBannerImg({position: 67})

      Promise.all([banner, recommend, hot]).then(([bannerRes, recommendRes, hotRes]) => {
        if (bannerRes.code === 1000 && bannerRes.data.length) this.bannerData = bannerRes.data
        if (recommendRes.code === 1000 && recommendRes.data.length) this.recommendData = recommendRes.data
        if (hotRes.code === 1000 && hotRes.data.length) this.hotData = hotRes.data
      })

    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    mouseDownFun (event) {
      console.log('111', event, this.$refs.scrollDom.offsetLeft)
      this.prevX = event.touches[0].clientX
    },
    mouseMoveFun (event) {
      if (!this.scrollLock) return
      // console.log('222', event)
      let prevX = this.prevX
      let nextX = event.touches[0].clientX
      if (Math.abs(nextX - prevX) < 100) return
      let scrollDom = this.$refs.scrollDom
      console.log(nextX, prevX)
      // 向右滑
      if (nextX - prevX < 0) {
        if (scrollDom.offsetLeft <= -((this.bannerData.length - 1) * (284 + 12))) return
        this.scrollLock = false
        scrollDom.style.left = (scrollDom.offsetLeft - 284 - 24) + 'px'
      // 向左滑
      } else {
        if (scrollDom.offsetLeft === 0) return
        this.scrollLock = false
        scrollDom.style.left = (scrollDom.offsetLeft + 284 + 24) + 'px'
      }
      setTimeout(() => {
        this.scrollLock = true
      }, 600)
      // this.prevX = nextX
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./indes.scss";
</style>
